import { ReactElement } from 'react'
import { Helpers } from '@dustin-web/product-components/src/utils/product-digital-data'
import OnScreen from '@dustin-web/microsite-components/src/on-screen'
import { ProductCardCompact } from '@dustin-web/product-components/src/cards'
import type {
  ProductsQuery,
  TopSellingProductsQueryProducts,
} from '@dustin-web/microsite-baselayout/src/components/header/types'

type ProductsProps = {
  products: ProductsQuery | TopSellingProductsQueryProducts
  header: ReactElement
}

const Products = ({ products, header }: ProductsProps) => {
  return (
    <>
      {header}
      <ul className="c-header__autocomplete-mini-list">
        {products?.map((product, i) => (
          <OnScreen
            handleOnScreen={() => Helpers.formatAndPushViewItemList([product], 'searchDropDown')}
            as="li"
            key={i}
            className="c-header__autocomplete-mini-item">
            <ProductCardCompact
              ticket={product?.ticket || ''}
              digitalDataOrigin={'searchDropDown'}
              product={product?.searchResultProduct}
            />
          </OnScreen>
        ))}
      </ul>
    </>
  )
}

export default Products
